export const PRODUCTCATEGORY_LIST_REQUEST = "PRODUCTCATEGORY_LIST_REQUEST";
export const PRODUCTCATEGORY_LIST_SUCCESS = "PRODUCTCATEGORY_LIST_SUCCESS";
export const PRODUCTCATEGORY_LIST_FAIL = "PRODUCTCATEGORY_LIST_FAIL";

export const PRODUCTCATEGORY_DETAILS_REQUEST =
  "PRODUCTCATEGORY_DETAILS_REQUEST";
export const PRODUCTCATEGORY_DETAILS_SUCCESS =
  "PRODUCTCATEGORY_DETAILS_SUCCESS";
export const PRODUCTCATEGORY_DETAILS_FAIL = "PRODUCTCATEGORY_DETAILS_FAIL";

export const PRODUCTCATEGORY_CREATE_REQUEST = "PRODUCTCATEGORY_CREATE_REQUEST";
export const PRODUCTCATEGORY_CREATE_SUCCESS = "PRODUCTCATEGORY_CREATE_SUCCESS";
export const PRODUCTCATEGORY_CREATE_FAIL = "PRODUCTCATEGORY_CREATE_FAIL";
export const PRODUCTCATEGORY_CREATE_RESET = "PRODUCTCATEGORY_CREATE_RESET";

export const PRODUCTCATEGORY_UPDATE_REQUEST = "PRODUCTCATEGORY_UPDATE_REQUEST";
export const PRODUCTCATEGORY_UPDATE_SUCCESS = "PRODUCTCATEGORY_UPDATE_SUCCESS";
export const PRODUCTCATEGORY_UPDATE_FAIL = "PRODUCTCATEGORY_UPDATE_FAIL";
export const PRODUCTCATEGORY_UPDATE_RESET = "PRODUCTCATEGORY_UPDATE_RESET";

export const PRODUCTCATEGORY_DELETE_REQUEST = "PRODUCTCATEGORY_DELETE_REQUEST";
export const PRODUCTCATEGORY_DELETE_SUCCESS = "PRODUCTCATEGORY_DELETE_SUCCESS";
export const PRODUCTCATEGORY_DELETE_FAIL = "PRODUCTCATEGORY_DELETE_FAIL";
export const PRODUCTCATEGORY_DELETE_RESET = "PRODUCTCATEGORY_DELETE_RESET";

export const PRODUCTCATEGORY_UPDATE_STATUS_REQUEST =
  "PRODUCTCATEGORY_UPDATE_STATUS_REQUEST";
export const PRODUCTCATEGORY_UPDATE_STATUS_SUCCESS =
  "PRODUCTCATEGORY_UPDATE_STATUS_SUCCESS";
export const PRODUCTCATEGORY_UPDATE_STATUS_FAIL =
  "PRODUCTCATEGORY_UPDATE_STATUS_FAIL";
export const PRODUCTCATEGORY_UPDATE_STATUS_RESET =
  "PRODUCTCATEGORY_UPDATE_STATUS_RESET";
